







import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";

@Component
export default class Tab extends Vue {
  @Prop([String, Number])
  type: string | number;

  @Prop()
  title: string;

  @Prop()
  subtitle: number;

  @Prop()
  subtitlePostText: string;

  @Prop()
  isActive: boolean;

  @Prop()
  routeValue: string;

  @Prop({ default: true })
  isVisible: boolean;

  @Prop()
  routeTo: (t: Tab) => Location;

  @Prop()
  className: string;

  @Prop()
  iconType: string;

  @Prop()
  iconClass: string;

  active = false;

  created () {
    this.active = this.isActive;
  }

  mounted () {
    this.$nextTick(() => this.$parent.$emit("add-tab", this));
  }

  @Watch("isActive")
  onTabActiveChanged (newValue, oldValue) {
    if (newValue && newValue !== oldValue) {
      this.$parent.$emit("activate-tab", this);
    }
  }
}
